import React from 'react';

const STATUS_CONFIG = {
  draft:  { label: '⏳ Draft',  className: 'survey-badge-draft' },
  active: { label: '✓ Active', className: 'survey-badge-active' },
  closed: { label: '✗ Closed', className: 'survey-badge-closed' },
};

const SurveysList = ({ surveys, onEdit, onDelete, onStatusChange, actionLoading, loading }) => {
  const formatDate = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="surveys-empty">
        <div className="surveys-empty-icon">⏳</div>
        <p>Loading surveys…</p>
      </div>
    );
  }

  if (!surveys || surveys.length === 0) {
    return (
      <div className="surveys-empty">
        <div className="surveys-empty-icon">📋</div>
        <h3>No Surveys Found</h3>
        <p>Create your first survey to get started.</p>
      </div>
    );
  }

  return (
    <div className="surveys-table-wrap">
      <table className="surveys-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Status</th>
            <th>Questions</th>
            <th>Responses</th>
            <th>Anonymous</th>
            <th>Start</th>
            <th>End</th>
            <th>Created</th>
            <th style={{ textAlign: 'right' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {surveys.map((survey) => {
            const badge = STATUS_CONFIG[survey.status] || STATUS_CONFIG.draft;
            const isLoading = actionLoading === `survey-${survey.id}`;
            return (
              <tr key={survey.id}>
                <td>
                  <div className="surveys-title-cell">
                    <span className="surveys-title">{survey.title}</span>
                    {survey.slug && (
                      <span className="surveys-slug">/{survey.slug}</span>
                    )}
                  </div>
                </td>
                <td>
                  <span className={`survey-badge ${badge.className}`}>
                    {badge.label}
                  </span>
                </td>
                <td className="surveys-num">{survey.question_count ?? '—'}</td>
                <td className="surveys-num">{survey.response_count ?? '—'}</td>
                <td className="surveys-num">{survey.is_anonymous ? 'Yes' : 'No'}</td>
                <td>{formatDate(survey.start_date)}</td>
                <td>{formatDate(survey.end_date)}</td>
                <td>{formatDate(survey.created_at)}</td>
                <td>
                  <div className="surveys-actions">
                    {/* Edit */}
                    <button
                      className="survey-action-btn survey-btn-edit"
                      onClick={() => onEdit(survey)}
                      disabled={isLoading}
                      title="Edit survey"
                    >
                      ✏️
                    </button>

                    {/* Activate */}
                    {survey.status !== 'active' && (
                      <button
                        className="survey-action-btn survey-btn-activate"
                        onClick={() => onStatusChange(survey.id, 'active')}
                        disabled={isLoading}
                        title="Activate survey"
                      >
                        ▶
                      </button>
                    )}

                    {/* Deactivate → close */}
                    {survey.status === 'active' && (
                      <button
                        className="survey-action-btn survey-btn-deactivate"
                        onClick={() => onStatusChange(survey.id, 'closed')}
                        disabled={isLoading}
                        title="Close survey"
                      >
                        ⏹
                      </button>
                    )}

                    {/* Draft */}
                    {survey.status !== 'draft' && (
                      <button
                        className="survey-action-btn survey-btn-draft"
                        onClick={() => onStatusChange(survey.id, 'draft')}
                        disabled={isLoading}
                        title="Set back to draft"
                      >
                        ↩
                      </button>
                    )}

                    {/* Delete */}
                    <button
                      className="survey-action-btn survey-btn-delete"
                      onClick={() => onDelete(survey.id, survey.title)}
                      disabled={isLoading}
                      title="Delete survey"
                    >
                      🗑️
                    </button>

                    {isLoading && <span className="survey-spinner">⏳</span>}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SurveysList;
